import * as signalR from '@microsoft/signalr';
import { getWebBaseUrl } from '../config/appSettings';

/** Exact event name from AffiliateNotificationHub.ReceiveEvent */
export const AFFILIATE_NOTIFICATION_EVENT = 'ReceiveAffiliateNotification';

export const AFFILIATE_NOTIFICATION_HUB_PATH = '/affiliateNotificationHub';

export const getAffiliateNotificationHubUrl = () => {
  const base = getWebBaseUrl().replace(/\/$/, '');
  return `${base}${AFFILIATE_NOTIFICATION_HUB_PATH}`;
};

/**
 * Build SignalR connection for Affiliate notifications.
 * JWT via accessTokenFactory (fresh token on reconnect — do not lock a static string).
 */
export const createAffiliateNotificationConnection = (getAccessToken) => {
  const hubUrl = getAffiliateNotificationHubUrl();

  return new signalR.HubConnectionBuilder()
    .withUrl(hubUrl, {
      accessTokenFactory: () => {
        const token = typeof getAccessToken === 'function' ? getAccessToken() : '';
        return token || '';
      },
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000, 30000])
    .configureLogging(signalR.LogLevel.Warning)
    .build();
};
